export const modalImportClients = {
	feedback: {
		verifyBaseSheet:
			", por favor verifique el modelo de la hoja de ejemplo o utilícela como hoja base.",
		unidentifiedColum: "Error en los nombres de las columnas",
		emptySheet: "Esta hoja está vacía",
		emptyHeaderCell: "Faltan nombres en las columnas",
		sheetPoorlyFormatted:
			"Formatee la hoja para fuente Calibri, tamaño 11, elimine los espacios, saltos de línea innecesarios y negrita",
		default: "Ocurrió un error al importar la hoja",
		errorMessage:
			"Hoja inválida, descárguela nuevamente y realice los cambios necesarios.",
		download: "Descargar",
	},
	clients: "Clientes",
	import: "Importar clientes",
	invalidClientList: "Lista de Clientes (inválida)",
	importSheet: "Importar hoja",
	downloadSheet: "Descargar hoja de ejemplo",
	name: "Nombre",
	cpf: "CPF",
	phone: "Teléfono",
	addedClient: "cliente agregado",
	addedClients: "clientes agregados",
	emptyMessage: {
		title: "Ningún cliente agregado",
		description:
			"Agregue clientes por CPF o importando una lista de CPFs desde la hoja de ejemplo.",
	},
	add: "Agregar clientes",
};
